<button class="sku-tag row-container" #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="disabled ? null : skuMenu"
        appFocusRemove
        (menuOpened)="onOpened()">
  <span>{{colorName}} - {{sizeName}}{{suffix ? '（' + suffix + '）' : ''}}</span>
  <app-image-loading class="img-margin" src="assets/icon_arrow.svg" alt="選擇" i18n-alt *ngIf="!disabled"
                     [clickable]="true"
                     [targetWidth]="12"
                     [targetHeight]="16"/>
</button>
<mat-menu #skuMenu="matMenu" class="fit-menu">
  <button class="relative arrow-cursor" (click)="$event.stopPropagation()">
    <mat-spinner class="spinner" *ngIf="!viewModel.availableColors().length; else content"></mat-spinner>
    <ng-template #content>
      <div class="menu-container">
        <div class="flex">
          <span class="align-first-row" i18n>顏色</span>
          <div class="grids-color-container">
            <button class="border-frame" appFocusRemove
                    *ngFor="let color of viewModel.availableColors(); trackBy: trackByColor"
                    [class.selected]="viewModel.selectedColor() === color.color?.name"
                    (click)="onColorChange(color, $event)">
              <app-image-loading [targetWidth]="28"
                                 [targetHeight]="28"
                                 [clickable]="true"
                                 [tooltip]="color.color?.name ?? ''"
                                 [alt]="color.color?.name ?? ''"
                                 [src]="color.image?.img220 ?? ''"/>
            </button>
          </div>
        </div>
        <div class="row-container">
          <span i18n>尺碼</span>
          <div class="grids-size-container" [class.full-size]="viewModel.hasFullSizes()">
            <button class="size-tag" appFocusRemove
                    *ngFor="let size of viewModel.availableSizes(); trackBy: trackBySize"
                    [class.selected]="viewModel.selectedSize() === size.name"
                    (click)="onSizeChange(size, $event)">
              {{size.name}}{{size.suffix ? '（' + size.suffix + '）' : ''}}
            </button>
          </div>
        </div>
        <button class="common-button confirm-btn center-container" appFocusRemove
                (click)="onClosed();menuTrigger.closeMenu()">
          <span class="white-color" i18n>確定</span>
        </button>
      </div>
    </ng-template>
  </button>
</mat-menu>
